<template>
  <div v-if="challenge">
    <div class="text-center mb-24">
      <h1 class="px-4">
        <span v-if="isLastChallenge">Desafio Atual</span>
        <span v-else>Desafio #{{ challenge.number }}</span>
      </h1>
      <div
        v-if="challenge.started_at && !challenge.completed_at"
        class="px-4 font-bold text-lg text-yellow-500 flex  items-start leading-tight mb-8 uppercase"
      >
        <i class="material-icons font-bold text-lg mr-2 text-yellow-500">
          access_time </i
        >Desafio em Andamento
      </div>
      <div
        v-if="challenge.completed_at"
        class="px-4 font-bold text-lg text-green-400 flex  items-start leading-tight mb-5 uppercase"
      >
        <i class="material-icons font-bold text-lg mr-2 text-green-500">
          sentiment_satisfied_alt </i
        >Desafio Concluído
      </div>
    </div>

    <div class="swiper-container mt-5">
      <div class="swiper-wrapper">
        <div
          v-for="(lesson, index) in challenge.lessons"
          :key="index + 1"
          class="swiper-slide"
        >
          <!-- Se ele está em um challenge específico, vamos redirecionar pra lá -->
          <!-- Se ele está no último challenge, vamos manter no último challenge -->
          <router-link :to="routePath + (parseInt(index) + 1)">
            <challengeLessonCard
              class="mx-4"
              :challenge="challenge"
              :lesson="lesson"
            />
          </router-link>
        </div>
      </div>
      <!-- Add Arrows -->
      <div class="swiper-button-next"></div>
      <div class="swiper-button-prev"></div>
      <div class="swiper-pagination"></div>
    </div>
  </div>

  <div v-else>
    <NoChallengesYet />
  </div>
</template>

<script>
import "swiper/css/swiper.min.css";
import Swiper from "swiper";
import ChallengeLessonCard from "./ChallengeLessonCard.vue";
import NoChallengesYet from "./NoChallengesYet";
export default {
  name: "Challenge",
  data() {
    return {
      routePath: "/desafio/aula/",
      isLastChallenge: true
    };
  },
  props: { challenge: Object },
  components: {
    ChallengeLessonCard,
    NoChallengesYet
  },

  methods: {},
  created() {
    if (this.$route.params.challengeId) {
      this.isLastChallenge = false;

      this.routePath = `/desafio/${this.$route.params.challengeId}/aula/`;
      this.$store.dispatch(
        "fetchSelectedChallenge",
        this.$route.params.challengeId
      );
    } else {
      this.isLastChallenge = true;

      this.$store.dispatch("fetchLastChallenge").then(() => {});
    }
  },
  updated() {
    var swiper = new Swiper(".swiper-container", {
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      slidesPerView: 1,
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      on: {
        init: () => {
          document.querySelector(".swiper-button-prev").style.display = "none";
        },
        slideChange: () => {
          // on the first slide
          if (swiper.activeIndex == 0) {
            document.querySelector(".swiper-button-prev").style.display =
              "none";
            document.querySelector(".swiper-button-next").style.display =
              "block";
          }
          // most right postion
          else if (swiper.activeIndex == swiper.slides.length - 1) {
            document.querySelector(".swiper-button-prev").style.display =
              "block";
            document.querySelector(".swiper-button-next").style.display =
              "none";
          }
          // middle positions
          else {
            document.querySelector(".swiper-button-prev").style.display =
              "block";
            document.querySelector(".swiper-button-next").style.display =
              "block";
          }
        }
      }
    });
  }
};
</script>
<style lang="scss" scoped>
.swiper-container {
  width: 100%;
  min-height: 250px;
}

.swiper-button-next,
.swiper-button-prev {
  color: #5f4d7c;
}

.swiper-button-next:after,
.swiper-button-prev:after {
  color: #5f4d7c;
  margin-top: -50px;
  font-size: 30px;
}

.swiper-pagination >>> .swiper-pagination-bullet-active {
  background-color: #5f4d7c;
}
</style>
